import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';
import { FilterUtils } from '../../../../../../../../utils/filter-utils';

@Component({
  selector: 'app-plant-life-footer',
  templateUrl: './plant-life-footer.component.html',
  styleUrls: ['./plant-life-footer.component.scss'],
  standalone: false
})
export class PlantLifeFooterComponent extends ProductMenuFooterComponent {
  protected readonly FilterUtils = FilterUtils;
}
